import styled from '@emotion/styled';
import COLORS from '$variables/colors';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.span`
  color: ${COLORS.red};
`;
